import { Header } from '@/components/Header';
import { UploadZone } from '@/components/UploadZone';
import { FileList } from '@/components/FileList';
import { useAppStore } from '@/hooks/useAppStore';

function App() {
  const files = useAppStore((state) => state.files);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Hero Section */}
        {files.length === 0 && (
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="gradient-text">图片格式转换</span>
            </h1>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              快速、高效的图片格式转换工具。支持 PNG、JPG、WebP、AVIF、GIF 等多种格式，
              在浏览器本地完成所有处理，保护您的隐私。
            </p>
          </div>
        )}

        {/* Upload Zone */}
        <UploadZone />

        {/* File List */}
        <FileList />

        {/* Footer */}
        {files.length === 0 && (
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
            <FeatureCard
              icon="🚀"
              title="极速转换"
              description="利用浏览器原生能力，本地处理图片，无需上传服务器"
            />
            <FeatureCard
              icon="🔒"
              title="隐私保护"
              description="所有处理在本地完成，图片不会离开您的设备"
            />
            <FeatureCard
              icon="🎨"
              title="多格式支持"
              description="支持 PNG、JPG、WebP、AVIF、GIF 等主流图片格式"
            />
          </div>
        )}
      </main>
    </div>
  );
}

function FeatureCard({ icon, title, description }: { icon: string; title: string; description: string }) {
  return (
    <div className="glass rounded-xl p-6 text-center card-hover">
      <div className="text-4xl mb-3">{icon}</div>
      <h3 className="text-lg font-semibold text-text-primary mb-2">{title}</h3>
      <p className="text-sm text-text-secondary">{description}</p>
    </div>
  );
}

export default App;